import React from "react";
import styles from "./AccountIssuesPage.module.css";
import { useHistory } from "react-router-dom";

import Header from "../components/Header";
import AccountIssueList from "components/AccountIssueList";
import alertIcon from "assets/alert_icon.svg";
import helpSupportIcon from "assets/help_support_icon.svg";
import { useAccount } from "utils/AccountInfoContext";
import mobile from "mobileBridge";
import environment from "environment";
import { NavigationSvc } from "../navigationScv";
import AccountIssueItem from "components/AccountIssueItem";
import { useTranslation } from "react-i18next";
export function AccountIssuesPage() {
  const navigationSvc = new NavigationSvc();
  const history = useHistory();
  const { issuesData, consentData } = useAccount();
  const { t } = useTranslation();

  const WEB_APP_COUNTRY = environment?.WEB_APP_COUNTRY;
  const isANZ = WEB_APP_COUNTRY === "AU";

  const getType = (type) => {
    switch (type) {
      case "phone-unverified":
      case "email-unverified":
      case "address-unverified":
        return "Verifications";
      case "credit-card-expired":
      case "credit-card-expiring":
        return "Billing Issues";
      case "event-spring-leadership-payment":
      case "event-free-enterprise-payment":
      case "event-family-reunion-payment":
        return "Event Issues";
      case "membership-suspended":
      case "membership-primary-billing-cc-missing":
      case "membership-primary-billing-ach-missing":
      case "membership-expired":
      case "membership-cancelled":
        return "Membership Issues";
      case "account-primary-contact-missing":
      case "account-primary-address-missing":
      case "account-primary-phone-missing":
      case "account-primary-email-missing":
        return "Personal Account Issues";
      default:
        return "Unknown Issue";
    }
  };

  const navigateToSection = (type) => {
    switch (type) {
      case "account-primary-contact-missing":
      case "account-primary-phone-missing":
      case "account-primary-email-missing":
        history.push("/personal");
        break;
      case "account-primary-address-missing":
        history.push("/addresses");
        break;
      default:
        history.push("/account");
        break;
    }
  };

  const accountIssue = {
    label: "Account Issue",
    message: t("You have issue(s) on your account"),
  };

  const processedData = issuesData
    ? issuesData
        .filter((item) => {
          // Exclude ACH issue for ANZ
          if (isANZ && item.Type === "membership-primary-billing-ach-missing") {
            return false;
          }
          return true;
        })
        .map((item) => {
          let label;
          switch (item.Type) {
            case "phone-unverified":
              label = t("Phone");
              break;
            case "email-unverified":
              label = t("Email");
              break;
            case "address-unverified":
              label = t("Address");
              break;
            default:
              label = t("Unknown");
              break;
          }
          return {
            category: getType(item.Type),
            label: getType(item.Type),
            message: t(item.IssueMessage),
            Type: item.Type,
          };
        })
    : [];
  // if (!consentData) {
  //   processedData.push({
  //     category: "Account Issues",
  //     label: "Amway Account Issue",
  //     message:
  //       "There is an issue with your Amway account. Please contact support.",
  //     Type: "amway-account-issue",
  //   });
  // }
  const groupedIssues = processedData.reduce((acc, item) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }
    acc[item.category].push(item);
    return acc;
  }, {});
  const handleHeaderBackClick = () => {
    let _prevUrl = document.referrer;

    if (
      _prevUrl &&
      !_prevUrl.includes("settings") &&
      !_prevUrl.includes("apps-dev.wwdb.com") &&
      !_prevUrl.includes("apps-staging.wwdb.com") &&
      !_prevUrl.includes("wwdb.com")
    ) {
      window.location.assign(_prevUrl);
    } else {
      history.push("/");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Header header={t("Settings")} onClick={handleHeaderBackClick} />
      </div>

      <div className={styles.content}>
        {!isANZ && Object.keys(groupedIssues).length === 0 && !consentData ? (
          <div className={styles.amwayIssue}>
            <AccountIssueItem
              label={t("Amway Account Issue")}
              message={t("There is an issue with your Amway account")}
              buttonText={t("Help")}
              onClick={() => {
                if (mobile.isApp()) {
                  navigationSvc.goToApp("help", {});
                } else {
                  window.location.href = environment.helpUrl;
                }
              }}
              hideIcon={true} // Hide the icon for this special case
            />
          </div>
        ) : (
          Object.keys(groupedIssues).map((category, index) => (
            <AccountIssueList
              key={index}
              issues={groupedIssues[category]}
              category={category}
              onAddClick={(type) => navigateToSection(type)}
            />
          ))
        )}
        {!isANZ && !consentData && Object.keys(groupedIssues).length > 0 && (
          <div className={styles.amwayIssue}>
            <AccountIssueItem
              label={t("Amway Account Issue")}
              message={t("There is an issue with your Amway account")}
              buttonText={t("Help")}
              onClick={() => {
                if (mobile.isApp()) {
                  navigationSvc.goToApp("help", {});
                } else {
                  window.location.href = environment.helpUrl;
                }
              }}
              hideIcon={true} // Hide the icon for this special case
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default AccountIssuesPage;
